import { Popup } from "antd-mobile";
import React from "react";

import { CustomCard, CustomNavBar } from "../../../../components";
import styles from "./style.module.scss";

function DetailPopup(props) {
  const { detailItem } = props;

  const LinkifyText = ({ parts }) => {
    if (!parts) return;
    return (
      <p style={{ wordBreak: "break-word" }}>
        {parts.map((part, index) => {
          if (urlRegex.test(part)) {
            return (
              <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                {part}
              </a>
            );
          }
          return part;
        })}
      </p>
    );
  };

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  console.debug("detail", detailItem.content);
  const parts = detailItem?.content?.split(urlRegex);
  console.debug("parts", parts);
  return (
    <Popup
      className="custom-drawer-popup"
      {...props}
      position="right"
      bodyStyle={{ width: "100vw", backgroundColor: "var(--main-bg)" }}
    >
      <CustomNavBar onBack={props.onClose}>{detailItem?.title}</CustomNavBar>
      <div
        style={{
          padding: "12px",
          height: "calc(100vh - 45px)",
          overflowY: "scroll",
        }}
      >
        <CustomCard>
          <div className={styles.popupDetail}>
            <div className={styles.title}>{detailItem?.title}</div>
            <div className={styles.time}>{detailItem?.created_at}</div>
            <div className={styles.content}>{LinkifyText({ parts: parts })}</div>
          </div>
        </CustomCard>
      </div>
    </Popup>
  );
}

export default DetailPopup;
